import s from "./lesson-item.module.scss";
import classNames from "classnames";
import { format } from "date-fns";
import { useAppointmentModal } from "@features/appointment/appointment/model/useAppointmentModal";
import { TextWithEmoji } from "@shared/ui/text-with-emoji/text-with-emoji";

const weekDayNames = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];

export const LessonItem = ({
  appointment,
  date,
  endDate,
  isHighlighted,
  isLast,
  isTeacher
}) => {
  const { open: openModal } = useAppointmentModal();

  const timeString = endDate
    ? `${format(date, 'HH:mm')}-${format(endDate, 'HH:mm')}`
    : format(date, 'HH:mm');

  const dayNumber = format(date, 'd');
  const dayName = weekDayNames[date.getDay()];

  const person = appointment.teacher || appointment.student;
  const personName = person?.name || 'Неизвестно';

  const handleClick = () => {
    if (openModal && appointment.id) {
      openModal({ appointmentId: appointment.id });
    }
  };

  return (
    <div
      className={classNames(s.lessonItem, isHighlighted && s.highlighted, isLast && s.lastInSection)}
      onClick={handleClick}
    >
      {/* Дата */}
      <div className={s.lessonDate}>
        <span className={s.dayNumber}>{dayNumber}</span>
        <span className={s.dayName}>{dayName}</span>
      </div>

      {/* Timeline линия */}
      <div className={s.timelineContainer}>
        <div className={classNames(s.timelineLine, isLast && s.timelineLineShort)} />
      </div>

      {/* Информация */}
      <div className={s.lessonInfo}>
        <span className={s.lessonTime}>{timeString}</span>
        <span className={s.lessonPerson}>{personName}</span>
				<span className={s.lessonInstrument}><TextWithEmoji text={appointment.instrument?.name || 'Занятие'}/></span>
      </div>

      {/* Badge домашнего задания */}
      {isHighlighted && <span className={s.homeworkIndicator} />}
    </div>
  );
};
